import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { LoadingField, FormSelect } from "../Controls";
import style from "./styles.module.scss";

const initialFields = {
  TAXId: -1,
};

const ModalTax = ({ open, toggle, tax, services, onConfirm }) => {
  const [taxes, setTaxes] = useState(false);

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      services
        .taxes({})
        .then((res) => res.items)
        .then((items) => setTaxes(items));
    }
  }, [open]);

  useEffect(() => {
    if (tax) {
      setFields(tax);
    } else {
      setFields(initialFields);
    }
  }, [tax]);

  const onChange = (name, value) => {
    setFields({ ...fields, [name]: value });
    setErrors({ ...errors, [name]: undefined });
  };

  const handleSave = async () => {
    const errors = validate(fields);

    if (Object.keys(errors).length == 0) {
      setLoading(true);
      const tax = taxes.find((tx) => tx.TAXId == fields.TAXId);
      const result = await onConfirm({ ...fields, ...tax });
      setLoading(false);

      if (result == 200) {
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>Add tax</ModalHeader>
      <ModalBody>
        {taxes ? (
          <FormSelect
            name="TAXId"
            label="Tax Name"
            selectItems={taxes}
            getSelectItemId={(i) => i.TAXId}
            getSelectItemName={(i) => i.TAXName}
            value={fields.TAXId}
            onChange={onChange}
          />
        ) : (
          <LoadingField label="Tax Name" />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={false}
          onClick={() => handleSave()}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

function validate(fields) {
  Object.entries(fields).forEach(([name, value]) => {});

  return {};
}

export default ModalTax;
